<template>
  <div>
    <Top></Top>
    <!-- 上传文件  -->
    <div class="file">
      <el-upload class="upload-demo" action=" https://www.rakumart-2c.com:8080/api/upload/uploadFile"
        :on-success="handleAvatarSuccess" :data="{ token: token }" :show-file-list="false">
        <el-button size="small" type="primary">納品書添付</el-button>
      </el-upload>
      <div class="name" v-if="delivery_file" :title="delivery_file">
        <a :href="delivery_file" target="_blank">
          <i class="el-icon-folder-checked"></i>

          <span>納品書</span>
        </a>
      </div>
    </div>
    <div class="main w">
      <!-- 头部 -->
      <div class="head">
        <div class="logo">
          <router-link to="/">
            www.rakumart-2c.com
          </router-link>
        </div>
        <h2></h2>
        <p>
          <span class="fl" v-if="$route.query.ids != undefined">注文NO:{{ pordno }}</span>
          <span class="fl" v-else>注文NO:{{ pordno }}</span>
          <span class="fr">{{ time }}</span>
        </p>
      </div>
      <!-- 商品配送详情 -->
      <div class="content">
        <!-- title -->
        <ol>
          <li>NO</li>
          <li>選択</li>
          <li class="flex2">注文番号</li>
          <li>番号</li>
          <li>写真</li>
          <li class="flex2">商品規格</li>
          <li>購入数</li>
          <li>倉庫数</li>
          <li>出荷数</li>
          <li>単価（元）</li>
          <li>小計</li>
          <li>国内送料</li>
          <li>備考</li>
        </ol>
        <!-- 商品 -->
        <ul v-for="(item, index) in orderList" :key="index">
          <li>{{ index + 1 }}</li>
          <li>
            <input type="checkbox" name id class="checked" v-model="item.checked" @change="changeCheck"
              :disabled="flag" />
          </li>
          <li class="flex2">{{ item.ordno }}</li>
          <li>{{ item.rownum }}</li>
          <li>
            <div class="img">
              <router-link :to="item.type == 'rakumart'
                ? 'details?id=' + item.iid
                : `details1688?iid=${item.iid}&type=${item.type}${item.mi_id ? '&mi_id=' + item.mi_id : ''}`
                " target="_blank">
                <img :src="item.pic" alt />
                <div class="imgbox">
                  <img :src="item.pic" alt />
                </div>
              </router-link>
            </div>
          </li>
          <li class="flex2 color">
            <div class="p">
              <p v-if="item.size" :title="item.size">
                <span>サイズ:</span>
                {{ item.size }}
              </p>
              <p v-else :title="item.psize">
                <span>サイズ:</span>
                {{ item.psize }}
              </p>
              <p :title="item.color">
                <span>カラー:</span>
                {{ item.color }}
              </p>
            </div>
          </li>
          <li>{{ item.num }}</li>
          <li>{{ item.zaiko }}</li>
          <li>
            <input type="text" v-model="item.fasong" :disabled="flag" @blur="editNum(index, item.fasong, item.zaiko)" />
          </li>
          <li>{{ item.price }}</li>
          <li>{{ item.num * item.price }}</li>
          <li>{{ item.gnsong }}</li>
          <li v-if="$route.query.ids == undefined">
            <textarea v-model="item.beikao" :disabled="flag" @blur="beikao(1, index, item.beikao)"></textarea>
          </li>
          <li v-else>
            <textarea v-model="item.bei" @blur="beikao(1, index, item.bei)" :disabled="flag"></textarea>
          </li>
        </ul>
      </div>
      <!-- 物流信息 -->
      <div v-if="this.$route.query.ids == undefined">
        <div class="wuliu" v-if="kno >= 4">
          <div class="fl wuliu-box">
            <!-- title -->
            <ol>
              <li>箱No</li>
              <li>実際 重量(kg)</li>
              <li>縦(cm)</li>
              <li>横(cm)</li>
              <li>高さ(cm)</li>
              <li>体積(cm³)</li>
              <!-- <li>容積 重量(kg)</li> -->
              <li>配送会社</li>
              <li class="flex2">追跡番号</li>
            </ol>
            <!-- 内容 -->
            <ul v-for="(item, index) in freight" :key="index">
              <li>箱No{{ index + 1 }}</li>
              <li>{{ item.freight }}</li>
              <li>{{ item.c }}</li>
              <li>{{ item.k }}</li>
              <li>{{ item.g }}</li>
              <li>{{ item.tiji }}</li>
              <!-- <li>18.5</li> -->
              <li>
                <span v-if="item.wuliu == 'OCS黑猫post' || item.wuliu == 'OCS黑猫'">無在庫便</span>

                <el-select v-model="item.wuliu" placeholder="请选择" size="mini" :disabled="flag" v-else>
                  <el-option v-for="item1 in logistics" :key="item1.name" :label="item1.name"
                    :value="item1.value"></el-option>
                </el-select>
              </li>
              <li class="flex2">
                <a :href="'https://webcsw.ocs.co.jp/csw/ECSWG0201R00003P.do?cwbno=' +
                  item.pno
                  " target="_blank" v-if="item.wuliu == 'OCS'">
                  {{ item.pno }}</a>
                <a :href="'https://trackings.post.japanpost.jp/services/srv/search/direct?reqCodeNo1=' +
                  item.pno +
                  '&searchKind=S002&locale=ja'
                  " target="_blank" v-else-if="item.wuliu == '倉庫止め' || item.wuliu == '塔普旺EMS' || item.wuliu == 'EMS'">
                  {{ item.pno }}</a>
                <form name="toi" method="POST" id="searchNumAside" class="pc-form"
                  action="https://toi.kuronekoyamato.co.jp/cgi-bin/tneko" target="toiawase" v-else-if="item.pno">
                  <p>
                    <input type="hidden" name="number01" class="number01" :value="item.pno" />

                    <input id="ytc_pc_003" type="submit" class="submit getExpress" :value="item.pno" />
                  </p>
                </form>
              </li>
            </ul>
          </div>
          <div class="fr wuliufei">
            <!-- title -->
            <ol>
              <li>箱No</li>
              <li>決済重量(kg)</li>
              <li>費用(元)</li>
            </ol>
            <!-- 内容 -->
            <ul v-for="(item, index) in freight" :key="index">
              <li>NO.{{ index + 1 }}</li>
              <li>-</li>
              <li>{{ item.kin }}</li>
            </ul>
            <!-- 小计 -->
            <ul class="xiaoji">
              <li>
                <span v-if="newOrder.porder.fangfa == 'OCS黑猫post' ||
                  newOrder.porder.fangfa == 'OCS黑猫'
                ">無在庫便</span>
                <span v-else>{{ newOrder.porder.fangfa }}</span> 小計
              </li>
              <li></li>
              <li>{{ newOrder.sumKin }}</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 选项  -->
      <div class="operation">
        <div class="fl ck" v-show="!flag">
          <button style="color: #fff; background: #f3c622" @click="addCommodity">
            倉庫から
          </button>
          <button @click="delOrder">削除</button>
        </div>
        <!-- 提交 临时保存 -->
        <div v-if="$route.query.ids != undefined">
          <div class="fr deliver" v-if="!flag">
            <button @click="verifySite(0)">一時保存</button>
            <button style="color: #fff; background: #f3c622" @click="verifySite(1)">
              配送提出
            </button>
          </div>
        </div>
        <!-- 修改 付款 -->
        <div v-else>
          <!-- 再提交保存 -->
          <div class="fr deliver" v-if="!flag">
            <div v-if="kno == 0">
              <button @click="verifySite(0)">一時保存</button>
              <button style="color: #fff; background: #f3c622" @click="verifySite(1)">
                配送提出
              </button>
            </div>
            <div v-else>
              <!-- <button @click="verifySite(0)">一時保存</button> -->
              <button @click="verifySite(1)">配送再提出</button>
              <button style="color: #fff; background: #f3c622" @click="newPOrder">
                キャンセル
              </button>
            </div>
          </div>
          <!-- 修改 支付 -->
          <!--    -->
          <div class="fr deliver" v-else>
            <button v-if="kno == 0 || kno == 4" @click="editKno">編集</button>
            <router-link :to="{ name: 'payment', query: { ordno: pordno } }">
              <button style="color: #fff; background: #f3c622" v-if="kno == 4">
                入金する
              </button>
            </router-link>
            <button style="color: #fff; background: #f3c622" v-if="kno == 0" @click="verifySite(1)">
              配送提出
            </button>
          </div>
        </div>
        <!-- 其他费用 -->
        <div class="qita" v-if="kno >= 4">その他費用:{{ porder.ta }}元</div>

        <div class="fr huilv" v-if="flag">(レート：1元= {{ huilv }}円)</div>
        <div class="fr huilv" v-else>(レート：1元= {{ exchangeRate }}円)</div>
      </div>
      <!-- 地址 -->
      <div class="site">
        <!-- 輸入者(Importer) -->
        <div class="importer fl">
          <h3>輸入者(Importer)</h3>
          <el-select v-model="address1.remark" placeholder="配送先管理から選択" @change="selectSite($event, 1)" :disabled="flag">
            <el-option v-for="item in aid" :key="item.aid" :label="item.remark" :value="item.aid"></el-option>
          </el-select>
          <div class="importer-box">
            <ul>
              <li>
                会社：
                <input type="text" v-model="address1.company" :disabled="flag" />
              </li>
              <li>
                氏名：
                <input type="text" v-model="address1.realname" :disabled="flag"
                  @blur="verifySiteNull(address1.realname, 4)" />
              </li>
              <li>
                郵便：
                <input type="text" v-model="address1.zip" @blur="verifySiteNull(address1.zip, 1)" :disabled="flag" />
              </li>
              <li>
                住所：
                <input type="text" v-model="address1.address" @blur="verifySiteNull(address1.address, 2)"
                  :disabled="flag" />
              </li>
              <li>
                携帯番号：
                <input type="text" v-model="address1.mobile" @blur="verifySiteNull(address1.mobile, 3)"
                  :disabled="flag" />
              </li>
            </ul>
          </div>
        </div>
        <!-- 配送先 -->
        <div class="importer fl">
          <h3>配送先</h3>
          <el-select v-model="address2.remark" placeholder=" 配送先管理から選択" @change="selectSite($event, 2)"
            :disabled="flag">
            <el-option v-for="item in hid" :key="item.aid" :label="item.remark" :value="item.aid"></el-option>
          </el-select>
          <div class="importer-box">
            <ul>
              <li>
                会社：
                <input type="text" v-model="address2.company" :disabled="flag" />
              </li>
              <li>
                氏名：
                <input type="text" v-model="address2.realname" @blur="verifySiteNull(address2.realname, 4)"
                  :disabled="flag" />
              </li>
              <li>
                郵便：
                <input type="text" v-model="address2.zip" @blur="verifySiteNull(address2.zip, 1)" :disabled="flag" />
              </li>
              <li>
                住所：
                <input type="text" v-model="address2.address" @blur="verifySiteNull(address2.address, 2)"
                  :disabled="flag" />
              </li>
              <li>
                携帯番号：
                <input type="text" v-model="address2.mobile" @blur="verifySiteNull(address2.mobile, 3)"
                  :disabled="flag" />
              </li>
            </ul>
          </div>
        </div>
        <!-- 配送方式 -->
        <div class="way fl">
          <h3>配送会社を指定</h3>
          <el-select v-model="SubmitList.fangfa" placeholder="请选择">
            <el-option v-for="item in logistics" :key="item.name" :label="item.name" :value="item.name"
              :disabled="flag"></el-option>
          </el-select>
        </div>
        <!-- 备注 -->
        <div class="fr txt">
          <p>備考欄:</p>
          <textarea name id cols="50" rows="9" v-model="SubmitList.beikao" :disabled="flag"
            style="resize: none"></textarea>
        </div>
      </div>
    </div>
    <!-- 添加商品弹框 -->
    <div class="add">
      <el-dialog :visible.sync="addDialogVisible" width="80%">
        <h2>倉庫(配送依頼)追加</h2>
        <div class="container">
          <ol>
            <li class="flex2">注文番号</li>
            <li>選択</li>
            <li>NO</li>
            <li>写真</li>
            <li>サイズ</li>
            <li>カラー</li>
            <li>数量</li>
            <li>発送可数量</li>
            <li>単価</li>
            <li>小計</li>
            <li>国内送料</li>
            <li style="border: 0">オプション</li>
          </ol>
          <ul v-for="(item, index) in warehouseList" :key="index">
            <li class="flex2">{{ item.ordno }}-71</li>
            <li>
              <input type="checkbox" v-model="item.checked" @change="getAddTotal" />
            </li>
            <li>{{ index + 1 }}</li>
            <li class="img">
              <img :src="item.pic" alt />
            </li>
            <li>{{ item.psize }}</li>
            <li>{{ item.color }}</li>
            <li>{{ item.num }}</li>
            <li>
              <!-- <el-input v-model="item.fasong" size="small" type="number"></el-input> -->
              <input type="text" v-model="item.fasong" />
            </li>
            <li>{{ item.price }}</li>
            <li>{{ item.num * item.price }}</li>
            <li>{{ item.gnsong }}</li>
            <li style="border: 0">{{ item.poption }}</li>
          </ul>
        </div>
        <div class="foot">
          <button @click="addCommodityList">追加</button>
          <p>
            已选商品
            <span>{{ addtotal }}</span> 件
          </p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import {
  newPOrder,
  getWarehouseFrom,
  addDistribution,
  getAddress,
  addAddress1,
  updateDistribution,
  updateDeliveryOrderFile
} from "../../api/API/deliver";
import { getCurrentDate } from "../../utlis/utlis";
import { mapState } from "vuex";
export default {
  data() {
    return {
      delivery_file: "", //上传的文件
      flag: false,
      time: "", //当前时间
      token: localStorage.getItem("token"),
      // 请求参数
      list: {
        mod: "inc",
        act: "ordersys",
        str: "newPOrder",
        token: "",
      },
      newOrder: {}, //
      orderList: [], // 数据list
      address1: {}, // 地址1
      address2: {}, // 地址2
      porder: {}, // 订单详情
      freight: {}, // 运费详情
      ids: [], // 删除id
      idArr: [], // 获取id
      aid: [], // 发货id
      hid: [], // 配送id
      aaid: "", // 传输的id
      hhid: "", // 传输的id
      addDialogVisible: false, //弹框
      huilv: "", // 汇率
      logistics: [
        //   { name: "OCS" },
        // { name: "倉庫止め" },
        { name: "無在庫便" },
        { name: "POST便" },
        // { name: "EMS" },


      ], // 物流方式
      pordno: "", //订单号
      kno: "", // 订单状态
      value: "",
      value1: "",
      // 提交数据
      SubmitList: {
        pordno: "",
        kno: 1,
        aid: 1,
        hid: 1,
        fangfa: "",
        beikao: "",
        baojia_ids: [],
        ordno: [],
        fba: [],
        type: [],
        beikao2: [],
        rownum: [],
        fasong: [],
      },
      //   -------------------------------------------
      //仓库数据
      warehouseList: [],
      addList: [], // 添加的数据
      addtotal: 0, // 添加的数量
    };
  },
  components: {
    Top,
  },
  created() {
    //当前时间
    this.time = getCurrentDate();
    this.newPOrder();
  },
  computed: {
    ...mapState(["exchangeRate"]),
  },
  methods: {
    //上传文件
    handleAvatarSuccess(file) {
      if (file.code != 0) return this.$message.error(file.msg);
      this.delivery_file = file.data;
      let datas = {
        pordno: this.pordno,
        filePath: file.data,
      };
      updateDeliveryOrderFile(datas);
    },
    // 获取地址
    getAddress() {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "getAddress",
        token: this.token,
      };
      getAddress(list).then((res) => {
        if (res.code != 1) return;
        this.aid = res.data.delivery;
        this.hid = res.data.outlet;
      });
    },
    // 获取数据
    newPOrder() {
      this.list.token = this.token;
      this.getAddress();
      // 预览
      if (this.$route.query.ids != undefined) {
        this.list.ids = this.$route.query.ids;
        newPOrder(this.list).then((res) => {
          if (res.code != 1) return;
          this.newOrder = res.data;
          this.orderList = res.data.goods;
          //   this.logistics = res.data.logistics;
          if (res.data.address1 == "") {
            this.address1 = {
              company: "",
              realname: "",
              zip: "",
              address: "",
              mobile: "",
            };
          } else {
            this.address1 = res.data.address1;
          }
          if (res.data.address2 == "") {
            this.address2 = {
              company: "",
              realname: "",
              zip: "",
              address: "",
              mobile: "",
            };
          } else {
            this.address2 = res.data.address2;
          }

          this.pordno = res.data.pordno;
          console.log(res, 123);
          this.newOrdnoSubmit();
        });
        // 详情
      } else {
        this.flag = true;
        delete this.list.ids;
        this.list.str = "getPOrderDetail";
        this.list.pordno = this.$route.query.pordno;
        newPOrder(this.list).then((res) => {
          if (res.code != 1) return;
          this.newOrder = res.data;
          this.freight = res.data.freight;
          this.porder = res.data.porder;
          this.address1 = res.data.address1;
          this.address2 = res.data.address2;
          this.orderList = res.data.goods;

          this.SubmitList.fangfa = res.data.porder.fangfa
          this.SubmitList.beikao = res.data.porder.beikao;
          this.huilv = res.data.porder.huiru;
          //   this.logistics = res.data.logistics;
          this.pordno = res.data.porder.pordno;
          this.kno = res.data.porder.kno;
          this.delivery_file = res.data.porder.delivery_file;
          console.log(res);
          this.newOrdnoSubmit();
        });
      }
    },
    // 创建提交数据
    newOrdnoSubmit() {
      this.idArr = [];
      this.SubmitList.baojia_ids = [];
      this.SubmitList.ordno = [];
      this.SubmitList.fba = [];
      this.SubmitList.type = [];
      this.SubmitList.beikao2 = [];
      this.SubmitList.rownum = [];
      this.SubmitList.fasong = [];
      this.orderList.forEach((item, index) => {
        this.idArr.push(item.id);
        this.SubmitList.baojia_ids.push(item.id == null ? "" : item.id);
        this.SubmitList.ordno.push(item.ordno == null ? "" : item.ordno);
        this.SubmitList.fba.push(item.fba == null ? "" : item.fba);
        this.SubmitList.type.push(item.type == null ? "" : item.type);
        this.SubmitList.beikao2.push(item.bei == null ? "" : item.bei);
        this.SubmitList.rownum.push(index + 1);
        this.SubmitList.fasong.push(item.fasong == null ? "" : item.fasong);
      });
      console.log(this.SubmitList);
    },
    // 获取id
    changeCheck() {
      this.ids = [];
      this.orderList.forEach((item) => {
        if (item.checked) {
          this.ids.push(item.id);
        }
      });
      console.log(this.ids);
    },
    // 添加商品
    addCommodity() {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "getWarehouseFrom",
        token: this.token,
        pordno: this.pordno,
        id: this.idArr.join(","),
      };
      this.warehouseList = [];
      getWarehouseFrom(list).then((res) => {
        if (res.code != 1) return this.$message.error(res.msg);
        if (res.data == false) return this.$message.error(res.msg);
        res.data.forEach((item) => {
          item.goods.forEach((item) => {
            this.warehouseList.push(item);
          });
        });
      });
      this.addtotal = 0;
      this.addDialogVisible = true;
    },
    // 删除
    delOrder() {
      for (let i = 0; i < this.ids.length; i++) {
        for (let j = 0; j < this.orderList.length; j++) {
          if (this.ids[i] == this.orderList[j].id) {
            this.orderList.splice(j, 1);
          }
        }
      }
      this.newOrdnoSubmit();
    },
    // 每项备注  或 fba
    beikao(i, index, bei) {
      // 备注
      if (i == 1) {
        this.SubmitList.beikao2[index] = bei;
        // fba
      } else if (i == 2) {
        this.SubmitList.fba[index] = bei;
      }
      console.log(this.SubmitList);
    },
    // 修改发送数
    editNum(index, num, zaiko) {
      if (num > zaiko) {
        this.orderList[index].fasong = zaiko;
        this.SubmitList.fasong[index] = zaiko;
      } else if (num < 1) {
        this.orderList[index].fasong = 1;
        this.SubmitList.fasong[index] = 1;
      } else {
        this.SubmitList.fasong[index] = num;
      }
    },
    // 地址
    selectSite(e, i) {
      if (i == 1) {
        this.aaid = e;
        this.aid.forEach((item) => {
          if (item.aid == e) {
            this.address1 = item;
          }
        });
      } else if (i == 2) {
        this.hhid = e;
        this.hid.forEach((item) => {
          if (item.aid == e) {
            this.address2 = item;
          }
        });
      }
    },
    // 验证地址不能为空
    verifySiteNull(data, i) {
      if (data == undefined || data == "") {
        console.log(i);
        if (i == 1) {
          this.$message.error("郵便をご記入ください。");
        } else if (i == 2) {
          this.$message.error("住所をご記入ください。");
        } else if (i == 3) {
          this.$message.error("携帯番号をご記入ください");
        } else if (i == 4) {
          this.$message.error("氏名をご記入ください");
        }
      }
    },
    // 验证地址
    verifySite(i) {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "addAddress1",
        token: this.token,
        company: this.address1.company,
        realname: this.address1.realname,
        zip: this.address1.zip,
        address: this.address1.address,
        mobile: this.address1.mobile,
        def1: 1,
        def2: 0,
        status: 0,
      };
      addAddress1(list).then((res) => {
        if (res.code != 1)
          return this.$message.error("輸入者をご記入ください。");
        this.SubmitList.aid = res.data.aid;
        list.company = this.address2.company;
        list.realname = this.address2.realname;
        list.zip = this.address2.zip;
        list.address = this.address2.address;
        list.mobile = this.address2.mobile;
        this.def1 = 0;
        this.def2 = 1;
        addAddress1(list).then((res) => {
          if (res.code != 1)
            return this.$message.error("配送先をご記入ください。");
          this.SubmitList.hid = res.data.aid;
          this.addDistribution(i);
        });
      });
    },
    // 一时保存/ 配送提出
    addDistribution(i) {
      this.SubmitList.pordno = this.pordno;
      this.SubmitList.filePath = this.delivery_file;
      this.SubmitList.kno = i;
      if (this.SubmitList.fangfa == "") {
        return this.$message.error("配送会社を指定");
      }
      //   console.log(this.SubmitList);
      let datas = {
        pordno: this.pordno,
        filePath: this.delivery_file,
      };
      updateDeliveryOrderFile(datas);
      if (this.kno >= 1) {
        updateDistribution(this.token, this.SubmitList).then((res) => {
          if (res.code != 1) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.$router.push("/user/deliverOrder");
        });
      } else {

        addDistribution(this.token, this.SubmitList).then((res) => {
          if (res.code != 1) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.$router.push("/user/deliverOrder");
        });
      }
    },
    // // 修改配送单
    // modification() {
    //   this.verifySite(1);
    // },
    payment() {
      this.$router.push({ path: "/payment", query: { ordno: this.orderID } });
    },
    // ------------------------添加仓库商品----------------------
    // 添加仓库商品
    addCommodityList() {
      this.addList = [];
      this.warehouseList.forEach((item) => {
        if (item.checked == true) {
          this.addList.push(item);
          item.checked = false;
        }
      });
      this.orderList = [...this.orderList, ...this.addList];
      this.newOrdnoSubmit();
      this.addDialogVisible = false;
    },
    //编辑状态
    editKno() {
      if (this.kno == 4) {
        this.$alert("編集される場合は担当者までご連絡ください。", {
          confirmButtonText: "確定",
          center: true,
        });
      } else {
        this.kno = 1;
        this.flag = false;
      }
    },
    //获取追加已选商品
    getAddTotal() {
      this.addtotal = 0;
      this.warehouseList.forEach((item) => {
        if (item.checked) {
          this.addtotal += 1;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "../../css/deliver";
</style>
